// extracted by mini-css-extract-plugin
export default {"example":"OrderPanelExample_example__y9q9u"};